export default "__VITE_ASSET__M8$YMj1i__"